import utils from 'blue-utils';
import publicState from '$config/store/state';

//扩展公共的state
const state = utils.extend(publicState, {
  /*项目相关的state*/
  view: {
    tabBar: 'home'
  },
  userInfo: {},

  // 选择地址
  selectAddressValue:{
    allSelect:{}, //地址所有信息
    addressName:'', //地址字符串
    bulidName:'', //建筑物名称
    location:''
  },
});

export default state;